<!-- New Solid Level Ring -->
<div
  [class]="[
    'rel',
    'rating-donut',
    'rating-donut--' + size,
    certified ? 'rating-donut--certified' : '',
    background ? 'rating-donut--background-level-ring' : '',
    background && size === 'sm'
      ? 'rating-donut--background-level-ring--sm'
      : '',
  ]"
>
  <!--Plus-->
  @if (showPlus) {
    <div
      class="rating-donut__plus absolute abs-center rating-donut__plus--{{
        size
      }}"
    >
      <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <path
          stroke-linecap="round"
          stroke-width="8"
          [attr.stroke]="brandColor"
          d="M25 5v40M5 25h40"
        />
      </svg>
    </div>
  }

  <!--  Lock for private ratings -->
  @if (showLock) {
    <div
      class="l_content rating-donut__lock absolute rating-donut__lock--{{
        size
      }}"
    >
      <df-icon icon="{{ 'eye-closed' }}" size="small"></df-icon>
    </div>
  }

  <!-- Pending ratings -->
  @if (showPending) {
    <df-icon
      class="rating-donut__pending rating-donut__pending--{{ size }}"
      icon="clock-filled"
      [size]="pendingIconSize"
    >
    </df-icon>
  }

  <!--Credential Seal (Degreed Certified)-->
  @if (showSeal) {
    <div
      class="rating-donut__credential-seal absolute abs-center rating-donut__credential-seal--{{
        size
      }}"
    >
      <svg viewBox="0 0 92 92" xmlns="http://www.w3.org/2000/svg">
        <title>{{ i18n.Cred_Certificate_SealAlt }}</title>
        <g fill="none" fill-rule="evenodd">
          <circle fill="#FFF" cx="46" cy="46" r="41" />
          <path
            d="M46 89.94L41.192 92l-4.278-3.02-5.13 1.01-3.558-3.848L23 86.057l-2.686-4.508-5.094-1.177-1.695-4.97-4.74-2.216-.63-5.217-4.178-3.157.462-5.235-3.435-3.96 1.534-5.025L0 46l2.54-4.593-1.535-5.024 3.434-3.96-.463-5.236 4.178-3.157.63-5.217 4.74-2.215 1.695-4.97 5.094-1.177L23 5.944l5.226-.085 3.56-3.848 5.128 1.01L41.192 0 46 2.06 50.808 0l4.278 3.02 5.13-1.01 3.558 3.848L69 5.943l2.686 4.508 5.094 1.177 1.695 4.97 4.74 2.216.63 5.217 4.178 3.157-.462 5.235 3.435 3.96-1.534 5.025L92 46l-2.54 4.593 1.535 5.024-3.434 3.96.463 5.236-4.178 3.157-.63 5.217-4.74 2.215-1.695 4.97-5.094 1.177L69 86.056l-5.226.085-3.56 3.848-5.128-1.01L50.808 92 46 89.94zm.005-3.128c22.417 0 40.59-18.272 40.59-40.812S68.42 5.188 46.004 5.188C23.59 5.188 5.417 23.46 5.417 46S23.59 86.812 46.005 86.812z"
            [attr.fill]="brandColor"
          />
        </g>
      </svg>
    </div>
  }

  <!--Glasses-->
  @if (showGlasses) {
    <div
      class="absolute abs-center rating-donut__glasses rating-donut__glasses--{{
        size
      }}"
    >
      <svg
        viewBox="14 13 57 36"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g fill="none" fill-rule="evenodd" transform="translate(14 13)">
          <mask id="b" fill="#fff">
            <path id="a" d="M.043.336H56.35v35.66H.042z" />
          </mask>
          <path
            [attr.fill]="inactiveColor"
            mask="url(#b)"
            d="M51.68 9.39a5.834 5.834 0 00-1.148-1.137c.434-.325.82-.708 1.148-1.137.328.43.715.812 1.15 1.137a5.871 5.871 0 00-1.15 1.137zm1.18-5.762H50.5c0 1.905-1.565 3.456-3.49 3.456v2.34c1.925 0 3.49 1.55 3.49 3.455h2.36c0-1.907 1.566-3.457 3.49-3.457v-2.34c-1.924 0-3.49-1.55-3.49-3.455z"
          />
          <path
            [attr.fill]="inactiveColor"
            mask="url(#b)"
            d="M48.082 25.537l-.007.16c-.102 2.082-.37 3.56-1.39 4.5-1.227 1.132-3.545 1.864-5.906 1.864-3.104 0-5.074-.53-6.59-3.34-1.974-3.66-2.068-6.094-1.51-6.586 1.176-1.036 2.712-2.048 7.34-2.048 2.33 0 7.18 0 7.648 1.19.554 1.405.51 2.3.414 4.26zM20.055 28.72c-1.515 2.81-3.484 3.34-6.59 3.34-2.36 0-4.678-.73-5.906-1.864-1.02-.94-1.287-2.417-1.39-4.5l-.007-.16c-.096-1.96-.14-2.855.413-4.26.47-1.19 5.318-1.19 7.648-1.19 4.63 0 6.165 1.012 7.342 2.048.557.492.463 2.925-1.51 6.586zm34.172-10.642v-.01a1.462 1.462 0 00-.076-.26l-.03-.067c-.03-.06-.063-.12-.1-.176-.013-.02-.025-.04-.04-.058a1.305 1.305 0 00-.176-.196c-.01-.01-.022-.014-.032-.023a1.301 1.301 0 00-.193-.134c-.01-.005-.02-.014-.03-.02-.678-.364-12.19-6.53-19.96-10.66-1.156.587-2.77 1.55-4.658 2.745 3.32 2.04 7.234 4.57 10.74 6.874-1.55.085-2.916.227-3.856.413-2.494.494-4.593 1.64-5.62 2.28-1.158.72-1.633.774-1.75.774H25.8c-.117 0-.592-.056-1.75-.776-1.03-.64-3.13-1.785-5.62-2.28-.94-.185-2.306-.327-3.857-.412 4.17-2.74 8.917-5.8 12.55-7.972 2.005-1.2 3.67-2.127 4.708-2.58l.26-.11c1.135-.45 2.228-.68 3.25-.68 2.612 0 4.047 1.46 4.425 1.908.75.886 1.566 1.335 2.426 1.335.838 0 1.443-.42 1.826-.735.534-.44.83-1.054.838-1.73.007-.748-.344-1.465-.99-2.018-2.474-2.106-5.18-3.174-8.04-3.174-3.366 0-6.257 1.476-8.17 2.454l-.325.165c-.062.03-.132.068-.208.106l-.207-.105-.325-.165C24.68 1.812 21.788.336 18.42.336c-2.86 0-5.564 1.068-8.04 3.177-.644.55-.996 1.267-.99 2.016.008.675.305 1.288.84 1.728.382.315.988.735 1.825.735.86 0 1.676-.45 2.424-1.335.377-.448 1.814-1.908 4.425-1.908 1.023 0 2.116.23 3.25.68l.26.11C14.765 9.595 1.428 16.74.695 17.132c-.01.006-.02.015-.03.02a1.37 1.37 0 00-.19.133c-.012.01-.023.015-.033.024-.066.06-.125.125-.178.195-.013.02-.025.04-.04.06a1.51 1.51 0 00-.1.176l-.03.07a1.3 1.3 0 00-.075.258c-.002.003 0 .007-.002.01-.01.07-.018.14-.018.21v3.22c0 .578.384 1.09.945 1.257.01.003 1.06.33 1.06 1.61v.253c-.01 2.43-.043 9.832 8.296 11.08 1.3.194 2.52.292 3.622.292 5.838 0 8.064-2.782 9.23-4.878.446-.8.828-1.71 1.197-2.587.802-1.91 1.632-3.888 2.773-3.888 1.14 0 1.97 1.977 2.773 3.888.37.878.75 1.786 1.197 2.59C32.26 33.217 34.483 36 40.323 36a24.8 24.8 0 003.623-.292c8.337-1.248 8.304-8.65 8.293-11.08l-.002-.253c0-1.19.902-1.555 1.062-1.61.56-.167.945-.68.945-1.257v-3.22c0-.07-.007-.14-.018-.21z"
          />
        </g>
      </svg>
    </div>
  }

  <!--Rating level ring-->
  <div class="rating-donut__level-ring rating-donut__level-ring--{{ size }}">
    <dgx-tag-rating-level-percentage-ring
      [size]="size"
      [maxLevel]="maxLevel"
      [currentLevel]="convertedLevel"
      [targetLevel]="targetLevel"
    ></dgx-tag-rating-level-percentage-ring>
  </div>

  <!--Level-->
  @if (convertedLevel) {
    <div class="ib absolute abs-center center-text">
      <div class="rating-donut__level rating-donut__level--{{ size }}">
        {{ convertedLevel }}
      </div>
    </div>
  }

  <!--Target indicator-->
  <div class="rating-donut__target ib abs-center absolute">
    <i
      #targetIndicator
      class="rating-donut__target-indicator ib rating-donut__target-indicator--{{
        size
      }}"
      [ngClass]="{ 'rating-donut__target--seal': showSeal }"
      [attr.aria-label]="i18n.Target_TargetLevelFormat"
    >
      <svg
        height="12"
        width="12"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          [attr.stroke]="targetIndicatorColor"
          [attr.d]="targetIndicatorPathDescription"
          [attr.stroke-width]="targetIndicatorStrokeWidth"
          stroke-linecap="round"
        />
      </svg>
    </i>
  </div>
</div>
